export default __webpack_public_path__ + "cf69ad6212d23776150a86d48fb7cb68.png";